import {runInAction} from 'mobx';
import {useEffect} from 'react';

import {appStore} from '@/entities/app';
import {getAuthToken} from '@/shared/lib/localStorage/authToken';
import {initInternalAnalytics} from '@/shared/services/analytics';
import {logger} from '@/shared/services/logger';
import {trRevisionHandler} from '@/sync/dtoHandlers/trRevisionHandler';

export function useInternalAnalytics() {
  useEffect(() => {
    (async () => {
      try {
        const {abtests} = await initInternalAnalytics({
          path: location.pathname,
          userAuthorized: Boolean(getAuthToken()),
          onInitResponse: ({tr_revision}) => {
            trRevisionHandler(tr_revision);
          },
        });
        runInAction(() => {
          appStore.addSignUpAbTests(abtests);
          appStore.setSingUpTestsReady(true);
        });
      } catch (error) {
        logger.warn('Failed to initialize internal analytics', {error});
      }
    })();
  }, []);
}
